module.exports = __webpack_public_path__ + "7ef67ef09dc7de4893f4ac17328a6a0e.pdf";